import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import Questions from './pages/Questions/Questions';
import Result from './pages/Result/Result';
import Login from './pages/Login/Login';
import ResultDetails from './pages/DetailsType/DetailsType';
import Home from './pages/Home/Home';
import Types from './pages/Types/Types';
import EneagramaWhat from './pages/EneagramaWhat/EneagramaWhat';
import RulesOne from './pages/RulesEneagrama/RulesOne';
import RulesTwo from './pages/RulesEneagrama/RulesTwo';
import AboutCaique from './pages/AboutCaique/AboutCaique';
import FriendsList from './pages/Friends/FriendsList';
import FriendResult from './pages/Friends/FriendResult';

export default function Routes() {
    return (
        <BrowserRouter>
            <Switch>
                <Route path="/" exact component={Login}/>
                <Route path="/questions" component={Questions}/>
                <Route path="/result" component={Result}/>
                <Route path="/details" component={ResultDetails}/>
                <Route path="/home" component={Home}/>
                <Route path="/types" component={Types}/>
                <Route path="/explanation" component={EneagramaWhat}/>
                <Route path="/rules" component={RulesOne}/>
                <Route path="/rules2" component={RulesTwo}/>
                <Route path="/aboutCaique" component={AboutCaique}/>
                <Route path="/friendsList" component={FriendsList}/>
                <Route path="/friendResult" component={FriendResult}/>
            </Switch>
        </BrowserRouter>
    )
}